import vDialog from '@/views/preSalePlan/common/dialog.vue'
import { mapGetters } from 'vuex'
const pubJs = {
  components: { vDialog },
  data() {
    return {
      authOptions: [],
    };
  },
  computed: {
    ...mapGetters({
      // 提报店铺情况 x（已提报店铺数）/x(店铺总数)
      reportNum: 'reportNum',
      // 是否已提报
      isReported: 'isReported',
      // 显示店铺
      storeId: 'storeId',
      // 月份tabs active 时间
      planTime: 'planTime',
      // 所有店铺已提报，全平台未提报
      isAllStoresReported: 'isAllStoresReported',
      // 全平台是否提报
      isAllReported: 'isAllReported',
      //预估监控选择的时间维度
      timeTypeName: 'timeTypeName',
    }),
    // 是否是全平台
    isAllPlan() {
      if(this.storeId == 0) {
        return true
      } else {
        return false
      }
    },
    optionsData() {
      return []
    },
    // 店铺权限下拉
    // authOptions() {
    //   return this.optionsData;
    // }
  },
 async created() {
    // localStorage.setItem('storeNameOptions', [])
   await this.get_authOptions();
  },
  methods: {
    get_authOptions() {
      this.authOptions = []
      // let options = localStorage.getItem('storeNameOptions');
      // if(options && options !== 'undefined' && options !== 'null' &&  options.length >0) {
      //   return JSON.parse(options);
      // }else{
        this.$q.preSalePlan.planGetStoreNameOptions()
          .then(res=>{
            if(res.success && res.data && res.data.storeNameOptions.length) {
              // localStorage.setItem('storeNameOptions', JSON.stringify(res.data.storeNameOptions));
              // location.reload();
              this.authOptions = res.data.storeNameOptions
            }
          });
      // }
    }
  },
};

export default pubJs
